import axios, { AxiosInstance, AxiosRequestConfig } from 'axios'

export let axiosInstance: AxiosInstance

export const initializeAxiosInstance = async (config: AxiosRequestConfig) => {
  axiosInstance = axios.create(config)
  return true
}
